import React from 'react'
import Forgot from '../Components/Forgot Password/Forgot'

const ForgotPage = () => {
  return (
    <Forgot />
  )
}

export default ForgotPage